import { css } from 'lit';

// Shared shadow-DOM styles for all <gt-*> components. Design tokens are read
// via var(--token) — custom properties pierce shadow DOM, so components are
// themed by web/css/tokens.css (dark/light) with zero per-component config.
export const sharedStyles = css`
  :host {
    box-sizing: border-box;
    font-family: var(--font-ui, system-ui, sans-serif);
    color: var(--text, #e2e8f0);
  }
  :host *,
  :host *::before,
  :host *::after {
    box-sizing: border-box;
  }
  .mono {
    font-family: var(--font-mono, ui-monospace, monospace);
    font-variant-numeric: tabular-nums;
  }
  .up {
    color: var(--up, #22c55e);
  }
  .down {
    color: var(--down, #ef4444);
  }
  .flat {
    color: var(--muted, #94a3b8);
  }
  .label {
    font-size: var(--fs-label, 0.68rem);
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--muted, #94a3b8);
  }
`;

// Map a signed number to a semantic state class name.
export function stateOf(v) {
  if (v == null || v === '' || Number.isNaN(+v)) return 'flat';
  return +v > 0 ? 'up' : +v < 0 ? 'down' : 'flat';
}
